/**
 * Tracks a remarketing event with Google.
 *
 * @param event The event to track.
 * @param data The data to track.
 */
export function googleRemarketingTrack({ event, data }: { event: string, data: Gtag.CustomParams | Gtag.EventParams }) {
  log('googleRemarketingTrack', { event, data })

  window?.gtag?.('event', event, data)
}
